import Vue from 'vue'
import Vuex from 'vuex'
import { login as loginApi } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        user: JSON.parse(localStorage.getItem('userInfo') || '{}')
    },
    getters: {
        isLoggedIn: state => !!state.token,
        currentUser: state => state.user
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        SET_USER(state, user) {
            state.user = user
            localStorage.setItem('userInfo', JSON.stringify(user))
        },
        LOGOUT(state) {
            state.token = ''
            state.user = {}
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
        }
    },
    actions: {
        async login({ commit }, { username, password }) {
            try {
                const response = await loginApi(username, password)
                const { token, user, role } = response

                // 合并角色信息到user对象，优先使用顶级role字段
                const userWithRole = { ...user, role: role || user.role || 'user' }

                console.log('[Store Login] Response role:', role)
                console.log('[Store Login] User role:', user.role)
                console.log('[Store Login] Merged role:', userWithRole.role)

                commit('SET_TOKEN', token)
                commit('SET_USER', userWithRole)

                return Promise.resolve(response)
            } catch (error) {
                return Promise.reject(error)
            }
        },
        async logout({ commit }) {
            commit('LOGOUT')
            return Promise.resolve()
        }
    },
    modules: {
    }
})
